import React from 'react';
import { Poppins, StyledAvatar, TextOverflowTooltip } from 'src/common';
import { getProfileCredentials } from 'src/utils/auth';
import styled from 'styled-components';

const Div = styled.div`
  display: inline-flex;
  align-items: center;
  grid-gap: 8px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 85%;

  span {
    font-weight: 500;
    font-size: 13px;
  }
`;

interface AccessAvatarProps {
  name: string;
  imgUrl?: string | null;
  gradientBlue?: boolean;
}

export const AccessAvatar: React.FC<AccessAvatarProps> = ({ name, imgUrl, gradientBlue }) => {
  return (
    <Div>
      <StyledAvatar $small $xsmall src={imgUrl || ''} $gradientBlue={gradientBlue}>
        {getProfileCredentials(name)}
      </StyledAvatar>
      <TextOverflowTooltip>
        <span>{name}</span>
      </TextOverflowTooltip>
    </Div>
  );
};
